var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"value":_vm.value,"title":_vm.L('MyAppointment'),"width":"50","footer-hide":""},on:{"on-visible-change":_vm.visibleChange}},[_c('Table',{attrs:{"height":500,"columns":_vm.columns,"data":_vm.list}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }